<template>
    <div>
        <el-row>
            <div class="channel">
                <div class="title">
                    <span>{{channelTitle}}</span>
                </div>
                <!-- <div class="type-tab">
                    <el-tabs  type="card" @tab-click="handleClick" :value="getActiveName(tabArr)" >
                        <el-tab-pane
                            v-for="(item) in tabArr"   
                            :key="item.themeStyleCode "
                            :label="item.themeStyleName" 
                            :name="item.themeStyleName"
                          >
                            <span slot="label">
                                <span class="sapn-box">
                                    <span>{{item.themeStyleName}}</span>
                                    <el-tooltip
                                    v-if="(isAllbtn && showItembtn(item))"
                                    class="tooltip-item"
                                    effect="dark"
                                    :content="(item.themeStyleName) + '需进行操作'"
                                    transition
                                    placement="bottom-start">
                                        <div class="circular-red"></div>
                                    </el-tooltip>
                                </span>
                            </span>
                            <div class="tab-item" >
                                <PopForm
                                :popDataitem="item"
                                :isAllbtn="isAllbtn"
                                @passThrough='passThrough'
                                @sendBack='sendBack'
                                ></PopForm>
                            </div>                           
                        </el-tab-pane>
                    </el-tabs>
                </div> -->
                <div v-for="(item) in tabArr">
                    <PopForm
                    :popDataitem="item"
                    :isAllbtn="isAllbtn"
                    @passThrough='passThrough'
                    @sendBack='sendBack'
                    ></PopForm>
                    
                </div>
            </div>
        </el-row>
    </div>        
</template>
<script>
    import { mapGetters } from 'vuex'
    import DialogPop from './dialog-pop.vue'
    import PopForm from './quotaChange-approval-pop-form.vue'
    export default {
      name: 'quotaChange-approval-pop',
      props: {
        channelForm:{type:Object, default:()=>{} },
        dataForm:{type:Array,default:()=>[]},
        isAllbtn:{type:Boolean,default:true},

      },
      components: {
        DialogPop,
        PopForm
      },
      data () {
        return {
            tabList:[],
            tabName:'地标',
            childName:'',
            tabArr: [],
            activeName: '',
            tabIndex: '',
            channelTitle:'',
            itemData: '',
            allList:[],
            isSonbtn: true,
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
      },
      watch: {},
      created () {
        this.init()
      },
      mounted () {
        const tab = {index: 0}
        this.handleClick(tab)
      },
      updated () {},
      methods: {
        init () {
            this.getChannelitem()
            // this.getAllList()
        },
        // 判断是否展示红点
        showItembtn(item){
            if (item.data.length == 2) {
                let val = 
                    (
                    item.data[0].subAssignList[0].buChangeQty !== item.data[0].subAssignList[0].assignQty ||
                    item.data[1].subAssignList[0].buChangeQty !== item.data[1].subAssignList[0].assignQty
                    )
                    &&
                    (
                    item.data[0].subAssignList[0].buChangeQty !== null ||
                    item.data[1].subAssignList[0].buChangeQty !== null
                    )
                return val
                
            } else if (item.data.length == 3) {
                let val = 
                    (
                        item.data[0].subAssignList[0].buChangeQty !== item.data[0].subAssignList[0].assignQty ||
                        item.data[1].subAssignList[0].buChangeQty !== item.data[1].subAssignList[0].assignQty ||
                        item.data[2].subAssignList[0].buChangeQty !== item.data[2].subAssignList[0].assignQty
                    ) 
                    &&
                    (
                        item.data[0].subAssignList[0].buChangeQty !== null ||
                        item.data[1].subAssignList[0].buChangeQty !== null ||
                        item.data[2].subAssignList[0].buChangeQty !== null
                    )
                return val
            } else {
                return false
            }
        },
        getChannelitem () {
            let code = this.channelForm.themeStyleCode
            let itemList = []
            for (let i = 0; i < this.dataForm.length; i++) {
                if (code === this.dataForm[i].themeDetail.themeStyleCode && this.dataForm[i].subAssignList.length > 0) {
                        itemList.push({
                            'themeDetail':this.dataForm[i].themeDetail,
                            // 'gpActivityInfoVOList':this.dataForm[i].gpActivityInfoVOList,
                            'curAssignInfo':this.dataForm[i].curAssignInfo,
                            'subAssignList':this.dataForm[i].subAssignList
                        })
            }}
            this.allList = itemList
            this.getTaball(this.allList)
            let themeStyleName = itemList[0].themeDetail.themeStyleName
            if (themeStyleName) {
                this.channelTitle = this.channelForm.themeChannelEnName + '-' +  themeStyleName  
            }else {
                this.channelTitle = this.channelForm.themeChannelEnName
            }
        },
        // getAllList () {
        //     let itemIndex = []
        //     for (let item of this.allList) {
        //         let index = itemIndex.indexOf(item.themeDetail.themeStyleCode)
        //         if (index === -1) {
        //             itemIndex.splice(0,0,item.themeDetail.themeStyleCode)
        //             let data = [
        //                 {
        //                 'themeLevelCode':item.themeDetail.themeLevelCode,
        //                 'themeStyleName':item.themeDetail.themeStyleName,
        //                 'themeStyleCode':item.themeDetail.themeStyleCode,
        //                 'themeDetail':item.themeDetail,
        //                 'curAssignInfo':item.curAssignInfo,
        //                 'subAssignList':item.subAssignList
        //                 }
        //             ]
        //             this.tabArr.push(data)
                    
        //         } else {
        //             this.tabArr[index].push(
        //                 {
        //                     'themeLevelCode':item.themeDetail.themeLevelCode,
        //                     'themeStyleName':item.themeDetail.themeStyleName,
        //                     'themeStyleCode':item.themeDetail.themeStyleCode,
        //                     'themeDetail':item.themeDetail,
        //                     'curAssignInfo':item.curAssignInfo,
        //                     'subAssignList':item.subAssignList
        //                 }
        //             )
        //         }  
        //     }
        //     this.tabList =  this.tabArr.map((item)=>{
        //         return item.themeStyleName || item[0].themeDetail.themeStyleName
        //     }).join('、')
        //     console.log(this.tabArr,'9999999');
        // },
        getTaball (arr) {
            let map = {}
            let dest = [];
            for(let i = 0; i < arr.length; i++){
                let ai = arr[i];
                if(!map[ai.themeDetail.themeStyleCode]){
                    dest.push({
                        themeStyleCode: ai.themeDetail.themeStyleCode,
                        themeStyleName: ai.themeDetail.themeStyleName,
                        data: [ai]
                    });
                    map[ai.themeDetail.themeStyleCode] = ai;
                }else{
                    for(let j = 0; j < dest.length; j++){
                        let dj = dest[j];
                        if(dj.themeStyleCode == ai.themeDetail.themeStyleCode){
                            dj.data.push(ai);
                            break;
                        }
                    }
                }
            }
            this.tabArr = dest
            // console.log( this.tabArr,'tabArr');
            // this.tabList =  this.tabArr.map((item)=>{
            //     return item.themeStyleName
            // }).join('、')
            return dest
        },
        // 通过
        passThrough (item) {
            this.isSonbtn = false
            this.$emit("passThrough",item)
        },
        // 退回
        sendBack (item) {
            this.isSonbtn = false
            this.$emit("sendBack",item)
        },
        getActiveName(tabArr) {
            // 默认选择第一项
            return tabArr[0].themeStyleName
        },
        handleClick(tab) {
            let num = Number(tab.index)
            this.tabIndex = num
        },   
    }
}
</script>
<style lang="scss" scoped>
    .channel {
        margin-bottom: 30px;
        border-radius: 10px;
        background-color: #FFFFFF;
        padding: 0px 10px 10px 20px;
        .title {
            height: 50px;
            line-height: 50px;
            text-align: left;
            // height: 25px;
            color: #101010;
            font-size: 18px;
            font-weight: 600;
        }
        .type-tab {
            margin-top: 20px;
            position: relative;
            .circular-red {
                    position: absolute;
                    top: 0px;
                    right: 0px;
                    border-radius: 50%;
                    height: 10px;
                    width: 10px;
                    background-color: #cd1231;
                    z-index: 2;
                }
            ::v-deep .el-tabs__item.is-active {
                background-color: #409EFF;
                color: #FFFFFF;

            }
            ::v-deep .el-tabs__item {
                color: #101010;
                background-color: #FFFFFF;
                text-align: center;
                margin-right: 5px;
                min-width: 100px;
                border: none;
                border-top-left-radius: 5px;
                border-top-right-radius: 5px;
                height: 42px;
                padding: 0px !important;
 
            }
            ::v-deep .el-tabs__nav-scroll {
                border-bottom: 0;
            }
            ::v-deep .el-tabs--card>.el-tabs__header .el-tabs__nav {
                border: 0;
                margin-bottom: 0;
            }
            ::v-deep .el-tabs--card>.el-tabs__header {
                border-bottom: 0px solid #E4E7ED;
            }
            ::v-deep .el-tabs__content {
                overflow: hidden;
                position: relative;
                margin-top: -15px;
                background-color: #FFFFFF;
                padding: 20px 0px 0px 0px;
                border-radius: 8px;
                border-top-left-radius: 0px;
            }
        }
    }
</style>
